import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import ITEMS from '../data.json';
import GalleryList from './GalleryList.js';
import GalleryItem from './GalleryItem.js';

function Gallery() {
  return (
    <div className="gallery page">
      <Router>
        <Routes>
          <Route 
            exact 
            path='/' 
            element={<GalleryList items={ITEMS} />} 
          />
          <Route 
            path='/:path' 
            element={<GalleryItem />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default Gallery;
